import { Pipe, PipeTransform } from '@angular/core';
import { SmartFilterGrouping } from '../../../models/automation/smart-filter-grouping';

@Pipe({
  name: 'isSmartFilterGrouping',
  standalone: false
})
export class IsSmartFilterGroupingPipe implements PipeTransform {
  transform(value: any): boolean {
    return value instanceof SmartFilterGrouping;
  }
}
